module.exports = __webpack_public_path__ + "img/1723104727627-WhatsApp Image 2024-08-08 at 16.11.10.jpeg.0a33657c.webp";